module.exports = __webpack_public_path__ + "static/img/sub04_3.195f262.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sub/sub04_3.png
// module id = n38+
// module chunks = 1